import React from "react";
import "../styles/glass.css";

const GlassCard = ({ className = "", children, ...rest }) => {
  return (
    <div className={`glass-card ${className}`} {...rest}>
      {children}
    </div>
  );
};

export default GlassCard;
